<!--  -->
<template>
<div class="account">
    <div class="phone_login">
        <div class="logo">
            <button class="back" @click="back()"> <i class="el-icon-arrow-left"></i> 返回</button>
        </div>
        <h1>手机号绑定</h1>
        <el-form :model="ruleForm" :status-icon="false" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="手机号" prop="phone">
                <el-input type="text" placeholder="请输入手机号" v-model="ruleForm.phone" autocomplete="off" class="login_input"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
                <el-input type="text" placeholder="请输入短信验证码" v-model="ruleForm.code" autocomplete="off" class="login_input"></el-input>
                <button type="button" class="obtain" :disabled="disabled" @click="obtainCodex" :style="disabled ? 'color:#999' : ''">
                    {{ disabled ? time + "s后重新发送" : "发送验证码" }}
                </button>
            </el-form-item>
            <el-form-item>
                <button type="button" class="submit" @click="submitForm('ruleForm')">绑定</button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      disabled: false,
      phonetime: '',
      time: 60,
      ruleForm: {
        phone: '',
        code: ''
      },
      rules: {}
    }
  },
  components: {},
  created: function () {
    if (localStorage.getItem('phonetime')) {
      var code_time = localStorage.getItem('phonetime')
      this.time = code_time - Math.round(new Date().getTime() / 1000)
      if (this.time > 0) {
        this.disabled = true
      }
      this.phonetime = setInterval(() => {
        if (this.time <= 0) {
          this.disabled = false
          clearInterval(this.phonetime)
          localStorage.clear('phonetime')
        }
        this.time = code_time - Math.round(new Date().getTime() / 1000)
      }, 1000)
    }
  },
  mounted: function () {},
  methods: {
    submitForm: function (formName) {
      this.rules = {
        phone: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('*请输入手机号'))
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error('*手机号格式不正确，请重新输入'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        code: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('*输入验证码'))
            } else {
              let wxbindpampas = {
                'loginStr': localStorage.getItem('wxstr'),
                'mobile': this.ruleForm.phone,
                'verifyCode': this.ruleForm.code
              }
              this.oauthapi.wxbindmobile(wxbindpampas).then(res => {
                if (res.code == 0) {
                  localStorage.setItem('token', res.data.token)
                  localStorage.setItem('isNew', true)
                  /**
                                   * 登录成功获取用户信息
                                   */
                  this.oauthapi.userInfo().then(res => {
                    localStorage.setItem('userinfo', JSON.stringify(res.data))
                    localStorage.setItem('userId', res.data.userId)
                    this.$router.replace({
                      path: this.$route.query.path || '/home'
                    })
                  })
                }
              })
            }
          },
          trigger: 'blur'
        }]
      }
    },
    obtainCodex: function () {
      let _this = this
      this.rules = {
        phone: [{
          validator: (rule, value, callback) => {
            if (value == '') {
              callback(new Error('*请输入手机号'))
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error('*手机号格式不正确，请重新输入'))
            } else {
              this.getSendx()
            }
          },
          trigger: 'blur'
        }]
      }
    },

    getSendx: function () {
      let sendData = {
        businessType: 2,
        mobile: this.ruleForm.phone
      }
      this.oauthapi.send(sendData).then(res => {
        if (res.code == 1012) {
          this.disabled = true
          var time = new Date().getTime() / 1000
          var code_time = 0
          this.time = 60
          if (!localStorage.getItem('phonetime')) {
            code_time = Math.round(time) + 60
            localStorage.setItem('phonetime', code_time)
            this.phonetime = setInterval(() => {
              if (this.time <= 0) {
                localStorage.clear('phonetime')
                clearInterval(this.phonetime)
                this.disabled = false
              }
              this.time = code_time - Math.round(new Date() / 1000)
            }, 1000)
          } else {
            code_time = localStorage.getItem('phonetime')
            this.phonetime = setInterval(() => {
              if (this.time <= 0) {
                localStorage.clear('phonetime')
                clearInterval(this.phonetime)
                this.disabled = false
              }
              this.time = code_time - Math.round(new Date() / 1000)
            }, 1000)
          }
          this.$message.error(res.msg)
        } else if (res.code == 2002) {
          this.$alert(res.msg, '提示', {
            confirmButtonText: '我知道了',
            center: true,
            type: 'warning'
          })
        }
      })
    },

    back: function () {
      let activeName = 'account'
      this.$emit('back', activeName)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-message-box--center {
  padding-bottom: 0 !important;
}
.account {
    width: 580px;
    display: flex;
    justify-content: center;
    height: 720px;

    .logo {
        margin-top: 40px;
        width: 100%;
        height: 34px;
        cursor: pointer;

        img {
            width: 60px;
            height: 34px;
        }
    }

    .phone_login {
        width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    h1 {
        font-size: 30px;
        font-weight: bold;
        color: #34343a;
        text-align: center;
        margin-top: 60px;
    }

    .obtain {
        position: absolute;
        border: none;
        right: 0;
        background: none;
        color: $btnc;
        height: 100%;
    }

    .submit {
        background: $btnc;
        color: #ffffff;
        width: 350px;
        height: 36px;
        border-radius: 18px;
        margin-top: 40px;
    }

    p {
        text-align: center;
        color: #989ea2;
    }

    .back {
        background: none;
        border: none;
        ;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/login/phone.vue